import React, { useEffect } from 'react';
import { withStyles } from '@material-ui/core';
import PricingCard from './PricingCard';
import clsx from 'clsx';
import { bindActionCreators } from 'redux';
import * as actions from 'Store/actions';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import CenteredSpinner from '../CenteredSpinner';

const styles = theme => ({
  pricingCardsContainer: {
    display: 'flex',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  pricingCard: {
    marginLeft: 24,
    [theme.breakpoints.down('sm')]: {
      marginLeft: 0,
      marginTop: 24,
      width: '100%',
    },
  },
  firstPricingCard: {
    marginLeft: 0,
    marginTop: 0,
  },
  loadingContainer: {
    height: '70px',
    display: 'flex',
    justifyContent: 'center',
  },
});

function PricingPlans({ classes, getPlanData, planData }) {
  useEffect(() => {
    getPlanData();
  }, [getPlanData]);

  // TODO: Switch this after getting the active plan Id that is on the user
  const activePlanId = planData.availablePlans[0]?.planId;

  if (!planData.availablePlans.length) {
    return <CenteredSpinner />;
  }

  return (
    <div className={classes.pricingCardsContainer}>
      {planData.availablePlans.map((plan, index) => (
        <PricingCard
          key={plan.planId}
          planId={plan.planId}
          className={clsx(classes.pricingCard, index === 0 && classes.firstPricingCard)}
          pricePlan={plan.name}
          price={`$${plan.price}`}
          planDescription={plan.description}
          features={plan.features}
          isActive={plan.planId === activePlanId}
          activePlanId={activePlanId}
        />
      ))}
      <PricingCard
        isCustom
        className={classes.pricingCard}
        pricePlan="Custom"
        planDescription="Let's chat"
        features={[
          {
            mainText: 'We’ll work something out for you',
          },
        ]}
      />
    </div>
  );
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getPlanData: actions.getPlanData,
    },
    dispatch,
  );
}

function mapStateToProps({ planData }) {
  return {
    planData,
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(PricingPlans)));
